import { ReactComponent as OteLogo } from "../../assets/images/logo-footer.svg";
import "./footer-styles.css";
import React, { Fragment, useState } from "react";
import Modal from "../Modal/index";

const Footer = (props) => {
	const { t } = props;

	const [open, setOpen] = useState(false);

	const handleClose = () => {
		setOpen(false);
	};
	const handleOpen = () => {
		setOpen(true);
	};
	return (
		<Fragment>
			<footer className={"static-footer"}>
				<OteLogo />
				<div className="links-line">
					<button type="button" onClick={handleOpen} className="footer-link">
						{t("terms")}
					</button>
					<a href="/cs/otegroup/gr/telekom_ae.html" className={"footer-link"}>
						{t("guideline")}
					</a>
					<a href="/cs/otegroup/gr/thigatrikes.html" className={"footer-link"}>
						{t("cookies")}
					</a>
				</div>
			</footer>
			{open ? <Modal open={open} onHide={handleClose} /> : null}
		</Fragment>
	);
};

export default Footer;
